import React from "react";
import PropTypes from "prop-types";

const Table = ({ header, rows }) => (
  <div className="vt__table" data-testid="vt-table">
    <div className="vt__table__header">{header}</div>
    {rows.map((row, index) => (
      <div className="vt__table__row" key={`vt__table__row__${index}`}>
        {row}
      </div>
    ))}
  </div>
);

export default Table;

Table.propTypes = {
  header: PropTypes.element.isRequired,
  rows: PropTypes.arrayOf(PropTypes.element).isRequired,
};
